/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Model } from '@app/shared/models/model.model';
import { HotelBooking } from '@app/hotels/hotel-bookings/hotel-booking.model';
import { Room } from '@app/hotels/rooms/room.model';
import { Night } from '@app/hotels/rooms/night.model';

export class HotelBookingCancellation extends Model {
  id: number;
  booking: HotelBooking;
  finished: boolean;
  nights: Array<Night>;
  note: string;

  deserialize(input: any): this {
    super.deserialize(input);

    if (input.booking) {
      this.booking = new HotelBooking().deserialize(this.booking);
    }
    if (input.booking && input.booking.rooms) {
      this.booking.rooms = input.booking.rooms.map((room: Room) => new Room().deserialize(room));
    }
    if (input.nights) {
      this.nights = input.nights.map((night: Night) => new Night().deserialize(night));
    }

    return this;
  }
}
